

export const navItemsNoAuth = [

    {
      id: 1,
      title: "LOGOUT",
      path: "./logout",
      cName: "",
    }
];
  
 
  
  